import { Calendars } from "src/models/calendars";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CalendarsEntityModel = createEntityModel<Calendars>();
